import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const EditDevModal = ({ show, handleClose, handleSave, dev }) => {
    const [formData, setFormData] = useState({});
    const [originalData, setOriginalData] = useState({});
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (dev) {
            setFormData(dev);
            setOriginalData(dev); // Store initial data for comparison
            if (dev.logo) {
                setImagePreviewUrl(dev.logo);
            }
        }
    }, [dev]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            // Extract the MIME type dynamically (e.g., image/png, image/jpeg)
            const mimeType = file.type;
            const base64Data = reader.result.split(',')[1]; // Extract base64 content
            const formattedBase64 = `data:${mimeType};base64,${base64Data}`;

            setFormData((prev) => ({
                ...prev,
                logo: formattedBase64, // Store properly formatted base64
            }));
            setImagePreviewUrl(reader.result); // Update image preview
        };
        reader.readAsDataURL(file);
    };


    const handleSaveClick = async () => {
        // Compare `formData` with `originalData` and keep only changed fields
        const updatedFields = Object.keys(formData).reduce((acc, key) => {
            if (formData[key] !== originalData[key]) {
                acc[key] = formData[key];
            }
            return acc;
        }, {});

        if (Object.keys(updatedFields).length === 0) {
            handleClose(); // No changes, just close modal
            return;
        }
        setLoading(true);
        try {
            await api.put(`/developers/${dev.id}`, updatedFields);
            handleSave({ id: dev.id, ...updatedFields }); // Pass only changed fields

            toast.success('Developer updated successfully!'); // Show success toast
        } catch (error) {
            console.error('Error updating developer:', error);
            toast.error('Failed to update developer.'); // Show error toast
        }
        setLoading(false);
    };


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Developer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Name */}
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
  {/* Name */}
  <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="text"
                            name="email"
                            value={formData.email || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Logo */}
                    <Form.Group className="mb-3">
                        <Form.Label>Logo</Form.Label>
                        <Form.Control type="file" onChange={handleFileUpload} accept="image/*" />
                        {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" style={{ maxWidth: '150px', marginTop: '10px' }} />}

                    </Form.Group>

                    {/* Contact Number */}
                    <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="contactNumber"
                            value={formData.contactNumber || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Address */}
                    <Form.Group className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            type="text"
                            name="address"
                            value={formData.address || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* IBAN */}
                    <Form.Group className="mb-3">
                        <Form.Label>IBAN</Form.Label>
                        <Form.Control
                            type="text"
                            name="iban"
                            value={formData.iban || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Swift Code */}
                    <Form.Group className="mb-3">
                        <Form.Label>Swift Code</Form.Label>
                        <Form.Control
                            type="text"
                            name="swiftCode"
                            value={formData.swiftCode || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Name of Account */}
                    <Form.Group className="mb-3">
                        <Form.Label>Name of Account</Form.Label>
                        <Form.Control
                            type="text"
                            name="nameOfAccount"
                            value={formData.nameOfAccount || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Bank Name */}
                    <Form.Group className="mb-3">
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="bankName"
                            value={formData.bankName || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Branch Number */}
                    <Form.Group className="mb-3">
                        <Form.Label>Branch Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="branchNumber"
                            value={formData.branchNumber || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Bank Address */}
                    <Form.Group className="mb-3">
                        <Form.Label>Bank Address</Form.Label>
                        <Form.Control
                            type="text"
                            name="bankAddress"
                            value={formData.bankAddress || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Segel Name */}
                    <Form.Group className="mb-3">
                        <Form.Label>Segel Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="segelName"
                            value={formData.segelName || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {/* Segel Number */}
                    <Form.Group className="mb-3">
                        <Form.Label>Segel Number</Form.Label>
                        <Form.Control
                            type="text"
                            name="segelNumber"
                            value={formData.segelNumber || ''}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSaveClick} disabled={loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditDevModal;
